/*
 * AdminClaimDisapproveModal Messages
 *
 * This contains all the text for the AdminClaimDisapproveModal component.
 */
import { defineMessages } from 'react-intl';
import { fieldNames } from './model';

export default defineMessages({
  [fieldNames.disapprovalReason]: {
    id: 'graphql.AdminClaimDisapproveModal.disapprovalReason',
    defaultMessage: 'Disapproval Reason',
  },
  modalTitle: {
    id: 'graphql.AdminClaimDisapproveModal.modalTitle',
    defaultMessage: 'Why do you disapprove this claim?',
  },
  submitButton: {
    id: 'graphql.AdminClaimDisapproveModal.submitButton',
    defaultMessage: 'Disapprove',
  },
});



// WEBPACK FOOTER //
// ./src/ui/admin/claims/AdminClaimDisapproveModal/messages.js